<template>
  <div class="supplier-register-page" data-name="供应商注册">
    <!-- 头部导航 -->
    <GlobalHeader />
    <!-- 主体内容区域 -->
    <div class="main-content">
      <p class="page-title">供应商注册信息填写</p>

      <a-form-model ref="ruleForm" :model="form" :rules="rules" class="register-form">
        <a-form-model-item label="供应商中文名称：" prop="name" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input size="large" v-model="form.name" placeholder="请填写供应商名称" />
        </a-form-model-item>

        <a-form-model-item label="统一社会信用代码：" prop="uscc" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input size="large" v-model="form.uscc" placeholder="请填写18位统一社会信用代码" />
        </a-form-model-item>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="联系人：" prop="contactName" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.contactName" placeholder="请填写姓名" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="邮箱：" prop="email" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.email" placeholder="请填写电子邮箱" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="登录手机号：" prop="phone" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input size="large" v-model="form.phone" placeholder="请填写登录手机号" />
            </a-form-model-item>

            <a-form-model-item label="登录密码：" prop="password" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-input-password size="large" v-model="form.password" placeholder="请填写登录密码" />
            </a-form-model-item>

            <a-form-model-item prop="smsCode" :wrapper-col="{ span: 16, offset: 8 }">
              <VerifyCodeInput v-model="form.smsCode" :phone-number="form.phone" :sms-code-type="2" send-type="register" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item :wrapper-col="{ span: 24 }" style="text-align: center; margin-top: 40px">
          <a-button type="primary" :loading="loading" @click="onSubmit" class="submit-button">
            确认注册
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import GlobalHeader from "@/components/GlobalHeader.vue";
import VerifyCodeInput from "@/components/VerifyCodeInput.vue";
import { supplierRegister } from "@/api/login.js";
export default {
  name: "SupplierRegister",
  components: {
    GlobalHeader,
    VerifyCodeInput,
  },
  data() {
    return {
      type: this.$route.query.type,
      loading: false,
      form: {
        name: "",
        uscc: "",
        password: "",
        contactName: "",
        phone: "",
        email: "",
        smsCode: "",
      },
      rules: {
        name: [
          { required: true, message: "请填写供应商名称", trigger: "blur" },
        ],
        uscc: [
          {
            required: true,
            message: "请填写18位统一社会信用代码",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请填写登录密码", trigger: "blur" },
        ],
        contactName: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请填写登录手机号", trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        email: [{ required: true, message: "请填写电子邮箱", trigger: "blur" }],
      },
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          supplierRegister(this.form).then((res) => {
            this.$message.success("注册成功");
            this.$router.push({
              path: "/login",
              query: {
                type: this.type,
              },
            });
          }).catch(err => {
            this.$message.info(err.message);
          }).finally(() => {
            this.loading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
@import "./Register.less";
</style>
